/**
 * Cart Facility Shipping Component
 * Handles the "Shipped directly to a facility" checkbox
 * Saves the selection as a cart attribute for warehouse visibility
 */
class CartFacilityShipping extends HTMLElement {
    constructor() {
        super();

        this.checkbox = this.querySelector('[data-facility-checkbox]');
        
        if (this.checkbox) {
            this.initCheckbox();
        }
    }

    /**
     * Initialize checkbox event listener
     */
    initCheckbox() {
        this.checkbox.addEventListener('change', () => {
            this.updateCartAttribute();
        });

        // Handle keyboard accessibility
        this.checkbox.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                this.checkbox.checked = !this.checkbox.checked;
                this.updateCartAttribute();
            }
        });
    }

    /**
     * Update cart attribute when checkbox changes
     */
    updateCartAttribute() {
        const isChecked = this.checkbox.checked;
        const attributeValue = isChecked ? 'Yes' : 'No';

        const body = JSON.stringify({
            attributes: {
                'Shipped directly to facility': attributeValue
            }
        });

        // Disable checkbox during update to prevent double-clicks
        this.checkbox.disabled = true;

        fetch(`${routes.cart_update_url}`, { ...Utility.fetchConfig(), body })
            .then((response) => {
                if (response.status === 200) {
                    // Sync all facility shipping checkboxes on the page
                    this.syncAllCheckboxes(isChecked);
                } else {
                    console.error('Failed to update cart attribute', response);
                    // Revert checkbox state on error
                    this.checkbox.checked = !isChecked;
                }
            })
            .catch((error) => {
                console.error('Error updating cart attribute', error);
                // Revert checkbox state on error
                this.checkbox.checked = !isChecked;
            })
            .finally(() => {
                this.checkbox.disabled = false;
            });
    }

    /**
     * Sync all facility shipping checkboxes on the page
     * This ensures cart drawer and cart page checkboxes stay in sync
     * @param {boolean} isChecked - The current checked state
     */
    syncAllCheckboxes(isChecked) {
        document.querySelectorAll('[data-facility-checkbox]').forEach(checkbox => {
            checkbox.checked = isChecked;
        });
    }
}

customElements.define('cart-facility-shipping', CartFacilityShipping);
